export { Palette19 } from "./Palette19";
